import styled from "styled-components";
import {useTranslation} from "react-i18next";
import useTitleAndDescription from "../../../common/hooks/useTitleAndDescription";
import {Footer, Header, Loading} from "../../common";
import {ErrorBoundary} from "react-error-boundary";
import CenterContentBox from "../../Champions/ContentWrapper";
import React, {Suspense} from "react";
import BottomStickAd from "../../ad/BottomStickAd";
import SllWinterContent from "./SllWinterContent";

const Wrapper = styled.div`
`;

const ContentWrapper = styled.div`
  min-height: 100px;
  display: flex;
  flex-direction: column;
  align-items: center;
`;



function Fallback({error, resetErrorBoundary}) {
    // Call resetErrorBoundary() to reset the error boundary and retry the render.

    return (
        <div role="alert">
            <p>Something went wrong:</p>
            <pre>{error.message}</pre>
        </div>
    );
}

const SllWinter = () => {
    const {t} = useTranslation();
    useTitleAndDescription({
        title: '2025 SOOP SLL WINTER 스크림  | DEEPLOL.GG',
        description: '2025 SOOP SLL WINTER 대회에 참가한 스트리머들의 스크림 경기와 AI-SCORE를 한눈에 확인하세요!',
    })
    return (
        <Wrapper>
            <Header/>
            <ContentWrapper>
                <ErrorBoundary FallbackComponent={Fallback}>
                    <CenterContentBox disableSponsor={true}>
                        <Suspense fallback={<Loading/>}>
                            <SllWinterContent/>
                        </Suspense>
                        {/*    <NewsContent/>*/}
                    </CenterContentBox>
                </ErrorBoundary>
            </ContentWrapper>
            <Footer/>
            <BottomStickAd/>
        </Wrapper>
    );
}

export default SllWinter